module.exports = __webpack_public_path__ + "img/blacklist-actif.86b9c30d.svg";